// Insurance policies in an Advice+ dossier (Fineco slides 7-8): one row per
// policy, product code in the ISIN column, "Tipo prodotto" from the polizze file.
// Shared by the dossier preview and the diagnosis/rebalancing composition.

export const POLIZZE_CODE_LABEL = 'Codice prodotto';
export const POLIZZE_SUBTOTAL_LABEL = 'Totale controvalore polizze';

export const polizzaTipoProdotto = (row: { tipo_prodotto?: string | null; is_gestione_separata?: boolean | null }) =>
  row.tipo_prodotto || (row.is_gestione_separata ? 'Gestione separata' : 'Polizza');

export const POLIZZE_TITLE = 'POLIZZE';

// «GESTIONE SEPARATA» sub-heading only when every policy is a Gestione separata.
export const polizzeSubTitle = (rows: Parameters<typeof polizzaTipoProdotto>[0][]) =>
  rows.length > 0 && rows.every((row) => polizzaTipoProdotto(row) === 'Gestione separata')
    ? 'GESTIONE SEPARATA'
    : null;

// Policy table columns (Fineco slides 7-8): the funds table's columns minus
// Tipologia, Final Score(s), P&L, Abbuoni, Dividend yield and Frequenza.
export const POLIZZE_COLUMN_LABELS = {
  isin: POLIZZE_CODE_LABEL,
  nome: 'Nome',
  tipo_prodotto: 'Tipo prodotto',
  valuta: 'Divisa',
  peso_sul_ptf: 'Peso',
  controvalore: 'Controvalore',
  microcategoria_advice: 'Microcategoria',
  ytm: 'YTM',
  rating_ESG: 'Rating ESG',
  duration: 'Duration',
  commissioni_gestione: 'Commissioni di gestione',
  costi_totali_stimati: 'Costi totali stimati',
};
